





import { Component, Vue, Prop } from "vue-property-decorator";
import AnalysisStatus from "./AnalysisStatus.vue";
import { AnalysisStatus as Status } from "@/api/analyses_status/types";
import * as analysisStatusService from "@/services/analyses_status";

@Component({
  name: "AnalysisStatusController",
  components: {
    AnalysisStatus,
  },
})
export default class AnalysisStatusController extends Vue {
  @Prop({ type: String, default: "" }) private analysisUuid!: string;

  private analysisStatusList: Status[] = [];

  private polling: any; 

  private async getAnalysisStatus() {
    this.analysisStatusList = await analysisStatusService.getByUuid(this.analysisUuid!);
  }

  private shouldTrackStatus() {
    let shouldTrack = false;

    if (Array.isArray(this.analysisStatusList)) {
      shouldTrack = this.analysisStatusList.some(
        (status) => (
          !status.finishedWithSuccess
          && !status.finishedWithError
          || status.processing
        )
      )
    } else {
      shouldTrack = true;
    }

    return shouldTrack;
  }

  private trackStatus(force = false) {
    if (this.shouldTrackStatus() || force) {
      this.polling = setTimeout(async () => {
        await this.getAnalysisStatus();
        this.trackStatus();
      }, force ? 1000 : 5000);
    }
  }

  private async mounted() {
    this.trackStatus(true);
  }

  private beforeDestroy() {
    if (this.polling) {
      clearTimeout(this.polling);
      this.polling = null;
    }
  }

}
